import React from 'react';
import classNames from 'classnames';
import Icon from 'material-ui/svg-icons/action/reorder';

export default class extends React.PureComponent {
  render() {
    return <Icon {...this.props} className={classNames('icon reorder', this.props.className)} />;
  }
}
